export default __webpack_public_path__ + "static/media/strategyImg4.7f3cd7f3.jpg";